import React from 'react'
import { PageTitle } from '../../layout/core'
import PaymentDetailsPage from './PaymentDetailsPage'

const PaymentPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Payment Details</PageTitle>
      <PaymentDetailsPage />
    </>
  )
}

export default PaymentPage
